import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const matchAPI = createApi({
  reducerPath: "matchAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_DEV_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      // Extract authentication token from Redux store
      const token = getState().user.token || localStorage.getItem("TOKEN");

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Matches"],
  endpoints: (builder) => ({
    getMyMatches: builder.query({
      query: (payload) => {
        let url = `/match/my-matches?status=${payload.status}&allTournaments=${payload.allTournaments}&allIndividual=${payload.allIndividual}`;
        if (payload.playerId) {
          url += `&playerId=${payload.playerId}`;
        }
        return { url };
      },
      providesTags: ["Matches"],
    }),
    createMatch: builder.mutation({
      query: (payload) => ({
        url: "match/create",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Matches"],
    }),

    changeMatchState: builder.mutation({
      query: (payload) => ({
        url: "match/changeMatchState",
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["Matches"],
    }),
    getMatchDetail: builder.query({
      query: (payload) => ({
        url: `/match/detail?teamId=${payload.teamId}&matchId=${payload.matchId}&page=members`,
      }),
      providesTags: ["Matches"],
    }),
    getMatchesForPlayer: builder.query({
      query: (payload) => ({
        url: `match/my-matches?playerId=${payload.playerId}&status=${payload.status}&allTournaments=${payload.allTournaments}&allIndividual=${payload.allIndividual}`,
      }),
      providesTags: ["Matches"],
    }),
    getMatchScoreCard: builder.mutation({
      query: (payload) => ({
        url: "match/scoreBoard",
        method: "POST",
        body: payload,
      }),
    }),
    editMatch: builder.mutation({
      query: (payload) => ({
        url: "match/edit",
        method: "PUT",
        body: payload,
      }),
    }),
    getMvpMatchDetail: builder.query({
      query: (payload) => ({
        url: `match/detail?matchId=${payload?.matchId}&page=${payload?.page}`,
      }),
      providesTags: ["Matches"],
    }),
    getSpecificMatchDetails: builder.query({
      query: (payload) => ({
        url: `match/detail?matchId=${payload?.matchId}&page=${payload?.page}`,
      }),
    }),
    getSummaryBestPerfomance: builder.query({
      query: (payload) => ({
        url: `sse/subscribe-sse/match/${payload?.matchId}`,
      }),
    }),
  }),
});

export const {
  useCreateMatchMutation,
  useEditMatchMutation,
  useGetMyMatchesQuery,
  useGetMatchDetailQuery,
  useLazyGetMatchDetailQuery,
  useGetMatchesForPlayerQuery,
  useGetMatchScoreCardMutation,
  useChangeMatchStateMutation,
  useGetMvpMatchDetailQuery,
  useLazyGetSpecificMatchDetailsQuery,
  useGetSummaryBestPerfomanceQuery,
} = matchAPI;
